export default __webpack_public_path__ + "static/quotes-single-59d94d186df82830edb3046c596441fc.png";